import { render, staticRenderFns } from "./YWList.vue?vue&type=template&id=3930a78a&scoped=true"
import script from "./YWList.vue?vue&type=script&lang=js"
export * from "./YWList.vue?vue&type=script&lang=js"
import style0 from "./YWList.vue?vue&type=style&index=0&id=3930a78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930a78a",
  null
  
)

export default component.exports